import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { ROLE_TYPE, URLPath } from "../utils/constantVariables";

export default function PublicRoute({ children }) {
    const { isLoggedIn, role } = useAuth();
    return !isLoggedIn ? children : <Navigate to={`${role === ROLE_TYPE.ADMIN ? URLPath.DASHBOARD : URLPath.COURSE_PLAYER}`} />;
}
